module.exports = __webpack_public_path__ + "static/YellowHeap-42a23b7bb785f4041a4fcdd31dd523ab.jpg";